import React, { Component } from "react";
import { Select, Dropdown, Menu, Empty, Spin, Progress, Tag } from "antd";
import { FileExcelOutlined, FilePdfOutlined, DownloadOutlined } from "@ant-design/icons";
import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { ButtonItem, RangePickerItem, TableItem, SelectItem, InputNumberItem, MensajeError } from "../../../../../Components/Items";
import { limpiarNombreArchivo } from "../../../../../Components/ExcelTablaReporte";
import reporteMotivosProduccionPdf from "../../../../../Pdf/reporteMotivosProduccionPdf";
import { estiloBarraFiltros } from "../PlaneacionProduccionPU/planeacion.utils";
import { agruparPareto, descargarReporteMotivosExcel } from "./reporteMotivos.utils";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const COLOR_BARRA = "#00BFD6";

const dinero = (v) => `$${(v || 0).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const etiquetaOrden = (orden) => [orden.folio, orden.partidaSnapshot?.nombre || orden.descripcion].filter(Boolean).join(" - ");

class ReporteMotivosPU extends Component {
  state = {
    loading: false,
    fechas: [moment().startOf("month"), moment().endOf("day")],
    flujoId: undefined,
    etapaIds: [],
    motivoIds: [],
    matrizId: undefined,
    costoMin: null,
    costoMax: null,
    ordenId: undefined,
    flujos: [],
    etapas: [],
    motivos: [],
    matrices: [],
    ordenes: [],
    buscandoOrdenes: false,
    entradas: [],
  };

  componentDidMount() {
    axios
      .post("motivosEtapaOrdenProduccionPU/datosPlantillaMotivos", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) this.setState({ flujos: res.data.flujos || [], etapas: res.data.etapas || [], motivos: res.data.motivos || [] });
      })
      .catch(() => {});
    this.buscarOrdenes("");
    this.consultar();
  }

  buscarOrdenes = (textoFiltro) => {
    clearTimeout(this.timeoutOrdenes);
    this.timeoutOrdenes = setTimeout(() => {
      this.setState({ buscandoOrdenes: true });
      axios
        .post(
          "ordenesDeProduccionPU/selectTodasOrdenes",
          { empresaId: this.props.empresaId, page: 1, pageSize: 20, textoFiltro, vista: "todas", sortField: "createdAt", sortOrder: "descend" },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.success !== 2) return this.setState({ buscandoOrdenes: false });
          const encontradas = res.data.data || [];
          const seleccionada = this.state.ordenes.find((o) => o._id === this.state.ordenId);
          const ordenes = seleccionada && !encontradas.some((o) => o._id === seleccionada._id) ? [seleccionada, ...encontradas] : encontradas;
          this.setState({ ordenes, buscandoOrdenes: false });
        })
        .catch(() => this.setState({ buscandoOrdenes: false }));
    }, 300);
  };

  parametros = (conEmpresa) => ({
    empresaId: this.props.empresaId,
    desde: this.state.fechas[0].clone().startOf("day").toISOString(),
    hasta: this.state.fechas[1].clone().endOf("day").toISOString(),
    flujoId: this.state.flujoId,
    etapaIds: this.state.etapaIds,
    motivoIds: this.state.motivoIds,
    matrizId: this.state.matrizId,
    costoMin: this.state.costoMin,
    costoMax: this.state.costoMax,
    ordenId: this.state.ordenId,
    conEmpresa,
  });

  consultar = (conEmpresa = false) => {
    this.setState({ loading: true });
    return axios
      .post("ordenesDeProduccionPU/reporteMotivos", this.parametros(conEmpresa), { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.setState({ entradas: res.data.entradas || [], matrices: res.data.matricesDisponibles || [] });
          return res.data;
        }
        MensajeError({ message: res.data.error || "No se pudo generar el reporte" });
        return null;
      })
      .catch(() => {
        this.setState({ loading: false });
        MensajeError({ message: "Error al conectar con el servidor" });
        return null;
      });
  };

  descripcionFiltros() {
    const { fechas, flujoId, etapaIds, motivoIds, matrizId, costoMin, costoMax, ordenId, flujos, etapas, motivos, matrices, ordenes } = this.state;
    const orden = ordenId && ordenes.find((o) => o._id === ordenId);
    const partes = [orden ? `Orden ${etiquetaOrden(orden)}` : `Del ${fechas[0].format("DD/MM/YYYY")} al ${fechas[1].format("DD/MM/YYYY")}`];
    if (flujoId) partes.push(`Flujo: ${flujos.find((f) => f._id === flujoId)?.nombre || ""}`);
    if (etapaIds.length) partes.push(`Etapas: ${etapas.filter((e) => etapaIds.includes(e._id)).map((e) => e.nombre).join(", ")}`);
    if (motivoIds.length) partes.push(`Motivos: ${[...new Set(motivos.filter((m) => motivoIds.includes(m._id)).map((m) => m.nombre))].join(", ")}`);
    if (matrizId) {
      const matriz = matrices.find((m) => m._id === matrizId);
      partes.push(`Insumo: ${[matriz?.clave, matriz?.descripcion].filter(Boolean).join(" - ")}`);
    }
    if (costoMin !== null) partes.push(`Costo mín: ${dinero(costoMin)}`);
    if (costoMax !== null) partes.push(`Costo máx: ${dinero(costoMax)}`);
    return partes.join(" · ");
  }

  nombreArchivo = () => `${moment().format("DD MM YYYY")} Reporte_motivos_${limpiarNombreArchivo(this.descripcionFiltros()).slice(0, 60)}`;

  descargarExcel = () => {
    descargarReporteMotivosExcel({
      entradas: this.state.entradas,
      empresaNombre: this.props.empresaNombre,
      descripcionFiltros: this.descripcionFiltros(),
      nombreArchivo: this.nombreArchivo(),
    });
  };

  descargarPdf = () => {
    this.consultar(true).then((datos) => {
      if (!datos) return;
      pdfMake
        .createPdf(
          reporteMotivosProduccionPdf({
            entradas: datos.entradas || [],
            empresa: datos.empresa || { nombre: this.props.empresaNombre },
            descripcionFiltros: this.descripcionFiltros(),
            usuarioNombre: this.props.usuarioNombre,
          })
        )
        .download(`${this.nombreArchivo()}.pdf`);
    });
  };

  renderGrupos(grupos) {
    if (grupos.length === 0) return <Empty description="Sin movimientos con estos filtros" />;
    const columns = [
      {
        title: "Motivo",
        dataIndex: "motivo",
        key: "motivo",
        width: "32%",
        render: (motivo, fila) => (fila.motivoId ? motivo : <span style={{ color: "#999", fontStyle: "italic" }}>{motivo}</span>),
      },
      { title: "Piezas", dataIndex: "piezas", key: "piezas", width: 100, align: "right", render: (v) => (v || 0).toLocaleString("es-MX") },
      {
        title: "%",
        dataIndex: "porcentaje",
        key: "porcentaje",
        render: (porcentaje) => <Progress percent={porcentaje} size="small" strokeColor={COLOR_BARRA} format={(p) => `${p}%`} />,
      },
      { title: "% acumulado", dataIndex: "porcentajeAcumulado", key: "porcentajeAcumulado", width: 120, align: "right", render: (v) => `${v}%` },
      { title: "Costo", dataIndex: "costo", key: "costo", width: 120, align: "right", render: (v) => dinero(v) },
      { title: "Movimientos", dataIndex: "movimientos", key: "movimientos", width: 110, align: "right" },
    ];
    return grupos.map((grupo) => (
      <div key={grupo.etapaId} style={{ marginBottom: 20 }}>
        <div style={{ marginBottom: 6 }}>
          <b style={{ fontSize: 15 }}>{grupo.etapa}</b> <Tag>{grupo.flujo}</Tag>
          <span style={{ color: "#8c8c8c" }}>
            {grupo.total.toLocaleString("es-MX")} piezas · {dinero(grupo.costo)}
          </span>
        </div>
        <TableItem size="small" dataSource={grupo.motivos} columns={columns} rowKey={(fila) => `${fila.motivoId}-${fila.motivo}`} />
      </div>
    ));
  }

  render() {
    const etapasDelFlujo = this.state.etapas.filter((e) => !this.state.flujoId || e.flujoId === this.state.flujoId);
    const nombreFlujo = (id) => this.state.flujos.find((f) => f._id === id)?.nombre || "";
    const nombreEtapa = (id) => this.state.etapas.find((e) => e._id === id)?.nombre || "";
    const motivosDisponibles = this.state.motivos.filter(
      (m) => (!this.state.flujoId || m.flujoId === this.state.flujoId) && (!this.state.etapaIds.length || this.state.etapaIds.includes(m.etapaId))
    );
    const menuDescarga = (
      <Menu>
        <Menu.Item key="excel" icon={<FileExcelOutlined style={{ color: "#217346" }} />} onClick={this.descargarExcel}>
          Excel
        </Menu.Item>
        <Menu.Item key="pdf" icon={<FilePdfOutlined style={{ color: "#df0101" }} />} onClick={this.descargarPdf}>
          PDF
        </Menu.Item>
      </Menu>
    );

    return (
      <>
        <div style={estiloBarraFiltros}>
          <RangePickerItem
            allowClear={false}
            disabled={!!this.state.ordenId}
            value={this.state.fechas}
            format="DD/MM/YYYY"
            onChange={(fechas) => fechas && this.setState({ fechas }, () => this.consultar())}
          />
          <SelectItem
            allowClear
            placeholder="Orden de producción"
            width={260}
            filterOption={false}
            loading={this.state.buscandoOrdenes}
            onSearch={this.buscarOrdenes}
            value={this.state.ordenId}
            onChange={(ordenId) => this.setState({ ordenId }, () => this.consultar())}
          >
            {this.state.ordenes.map((orden) => (
              <Select.Option key={orden._id} value={orden._id}>
                {etiquetaOrden(orden)}
              </Select.Option>
            ))}
          </SelectItem>
          <SelectItem
            allowClear
            placeholder="Flujo"
            width={220}
            value={this.state.flujoId}
            onChange={(flujoId) => this.setState({ flujoId, etapaIds: [] }, () => this.consultar())}
          >
            {this.state.flujos.map((flujo) => (
              <Select.Option key={flujo._id} value={flujo._id}>
                {flujo.nombre}
              </Select.Option>
            ))}
          </SelectItem>
          <SelectItem
            mode="multiple"
            allowClear
            placeholder="Etapas"
            style={{ minWidth: 260 }}
            maxTagCount="responsive"
            optionLabelProp="label"
            optionFilterProp="title"
            value={this.state.etapaIds}
            onChange={(etapaIds) => this.setState({ etapaIds, motivoIds: [] }, () => this.consultar())}
          >
            {etapasDelFlujo.map((etapa) => (
              <Select.Option key={etapa._id} value={etapa._id} label={etapa.nombre} title={`${etapa.nombre} ${nombreFlujo(etapa.flujoId)}`}>
                {etapa.nombre} <span style={{ color: "#8c8c8c" }}>· {nombreFlujo(etapa.flujoId)}</span>
              </Select.Option>
            ))}
          </SelectItem>
          <SelectItem
            mode="multiple"
            allowClear
            placeholder="Motivos"
            style={{ minWidth: 240 }}
            maxTagCount="responsive"
            optionLabelProp="label"
            optionFilterProp="title"
            value={this.state.motivoIds}
            onChange={(motivoIds) => this.setState({ motivoIds }, () => this.consultar())}
          >
            {motivosDisponibles.map((motivo) => (
              <Select.Option
                key={motivo._id}
                value={motivo._id}
                label={motivo.nombre}
                title={`${motivo.nombre} ${nombreEtapa(motivo.etapaId)} ${nombreFlujo(motivo.flujoId)}`}
              >
                {motivo.nombre}{" "}
                <span style={{ color: "#8c8c8c" }}>
                  · {nombreEtapa(motivo.etapaId)} · {nombreFlujo(motivo.flujoId)}
                </span>
              </Select.Option>
            ))}
          </SelectItem>
          <SelectItem
            allowClear
            showSearch
            placeholder="Insumo (matriz)"
            width={260}
            optionFilterProp="title"
            value={this.state.matrizId}
            onChange={(matrizId) => this.setState({ matrizId }, () => this.consultar())}
          >
            {this.state.matrices.map((matriz) => (
              <Select.Option key={matriz._id} value={matriz._id} title={`${matriz.clave} ${matriz.descripcion}`}>
                {[matriz.clave, matriz.descripcion].filter(Boolean).join(" - ")}
              </Select.Option>
            ))}
          </SelectItem>
          <div style={{ width: 130 }}>
            <InputNumberItem
              dinero
              min={0}
              placeholder="Costo mínimo"
              value={this.state.costoMin}
              onChange={(costoMin) => this.setState({ costoMin: costoMin ?? null })}
              onBlur={() => this.consultar()}
              onPressEnter={() => this.consultar()}
            />
          </div>
          <div style={{ width: 130 }}>
            <InputNumberItem
              dinero
              min={0}
              placeholder="Costo máximo"
              value={this.state.costoMax}
              onChange={(costoMax) => this.setState({ costoMax: costoMax ?? null })}
              onBlur={() => this.consultar()}
              onPressEnter={() => this.consultar()}
            />
          </div>
          <div style={{ flex: 1 }} />
          <Dropdown overlay={menuDescarga} trigger={["click"]}>
            <ButtonItem cyan botonAncho icon={<DownloadOutlined />}>
              Descargar
            </ButtonItem>
          </Dropdown>
        </div>
        <div style={{ backgroundColor: "white", borderRadius: 12, padding: 20, boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)" }}>
          <Spin spinning={this.state.loading}>{this.renderGrupos(agruparPareto(this.state.entradas))}</Spin>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  empresaNombre: state.empresa.nombre,
  usuarioNombre: [state.user.nombre, state.user.apellidoPaterno, state.user.apellidoMaterno].filter(Boolean).join(" "),
});

export default connect(mapStateToProps)(ReporteMotivosPU);
